<template>
  <el-menu
    class="el-menu-vertical-demo"
    style="min-height: 800px;text-align: left"
    router
    :default-openeds="default_open"
  >
    <template v-if="$store.getters.getStorage.user.user.roles == 0">
      <el-submenu index="0">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>数据维护</span>
        </template>
        <el-menu-item-group index="0-1">
          <el-menu-item index="/inspectSupervise/report"
            ><i class="el-icon-tickets"></i
            ><span slot="title">报表中心</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/comment"
            ><i class="el-icon-tickets"></i
            ><span slot="title">评论管理</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/taskMaintenance" ><i class="el-icon-tickets"></i><span slot="title">任务查询</span></el-menu-item> -->
          <el-menu-item index="/inspectSupervise/select"
            ><i class="el-icon-tickets"></i
            ><span slot="title">遴选系统</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/systemaudit"
            ><i class="el-icon-tickets"></i
            ><span slot="title">系统审计</span></el-menu-item
          >
           <el-menu-item index="/inspectSupervise/drawDesignList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">设计单位审核</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/taskRevert"
            ><i class="el-icon-tickets"></i
            ><span slot="title">退件审核</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/userMaintenance"
            ><i class="el-icon-tickets"></i
            ><span slot="title">用户管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/regionInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">区域管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/administration"
            ><i class="el-icon-tickets"></i
            ><span slot="title">行政管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/customerInfoList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/configList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">配置管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/formConfig/list"
            ><i class="el-icon-tickets"></i
            ><span slot="title">表单配置</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawManage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">图库管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/supervise_compact"
            ><i class="el-icon-tickets"></i
            ><span slot="title">合同管理</span></el-menu-item
          >
           <el-menu-item index="/inspectSupervise/chargegs"
            ><i class="el-icon-tickets"></i
            ><span slot="title">收费方式</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawMessage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">短信模板</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/spotCheck"
            ><i class="el-icon-tickets"></i
            ><span slot="title">项目抽查</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          > -->
          <!-- <el-menu-item index="/inspectSupervise/drawNotice" ><i class="el-icon-tickets"></i><span slot="title">公告管理</span></el-menu-item> -->
          <!--<el-menu-item index="/inspectSupervise/statement/project" >&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">项目情况</span></el-menu-item>
            <el-menu-item index="/inspectSupervise/common/signature" >&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">签章测试</span></el-menu-item>-->
          <el-menu-item index="/inspectSupervise/infoConstruction"
            ><i class="el-icon-tickets"></i
            ><span slot="title">建设单位</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoDesign"
            ><i class="el-icon-tickets"></i
            ><span slot="title">勘察设计单位</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoItemtype"
            ><i class="el-icon-tickets"></i
            ><span slot="title">项目类型</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoPolicy"
            ><i class="el-icon-tickets"></i
            ><span slot="title">政策材料</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoStrong"
            ><i class="el-icon-tickets"></i
            ><span slot="title">强标强条类型</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawNotice"
            ><i class="el-icon-tickets"></i
            ><span slot="title">公告管理</span></el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
    </template>
    <template v-if="$store.getters.getStorage.user.user.roles == 5">
      <el-submenu index="0">
        <template slot="title">
          <i class="el-icon-tem-renwu"></i>
          <span>数据维护</span>
        </template>
        <el-menu-item-group index="0-1">
          <el-menu-item index="/inspectSupervise/comment"
            ><i class="el-icon-tickets"></i
            ><span slot="title">评论管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/taskMaintenance"
            ><i class="el-icon-tickets"></i
            ><span slot="title">任务查询</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/systemaudit"
            ><i class="el-icon-tickets"></i
            ><span slot="title">系统审计</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/greenList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">绿建报告</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/reportInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">报表查看</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/tablearea"
            ><i class="el-icon-tickets"></i
            ><span slot="title">统计报表</span></el-menu-item
          > -->
          <el-menu-item index="/inspectSupervise/drawManage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">图库管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/customerInfoList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawMessage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">短信模板</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawConfig"
            ><i class="el-icon-tickets"></i
            ><span slot="title">配置管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawProfessional"
            ><i class="el-icon-tickets"></i
            ><span slot="title">专业配置</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/supervise_compact"><i class="el-icon-tickets"></i><span slot="title">合同管理</span></el-menu-item> -->
          <el-menu-item index="/inspectSupervise/drawDesignList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">设计单位审核</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoConstruction"
            ><i class="el-icon-tickets"></i
            ><span slot="title">建设单位</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoDesign"
            ><i class="el-icon-tickets"></i
            ><span slot="title">勘察设计单位</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoItemtype"
            ><i class="el-icon-tickets"></i
            ><span slot="title">项目类型</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoPolicy"
            ><i class="el-icon-tickets"></i
            ><span slot="title">政策材料</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoStrong"
            ><i class="el-icon-tickets"></i
            ><span slot="title">强标强条类型</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/drawNotice" ><i class="el-icon-tickets"></i><span slot="title">公告管理</span></el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>
    </template>
    <template v-if="$store.getters.getStorage.user.user.roles == 6">
      <el-menu-item index="/inspectSupervise/taskMaintenance"
        ><i class="el-icon-tickets"></i
        ><span slot="title">任务查询</span></el-menu-item
      >
    </template>
  </el-menu>
</template>
<script>
export default {
  data() {
    return {
      route_active: "",
      default_open: []
    };
  },
  mounted() {
    //初始化
    switch (this.$store.getters.getStorage.user.user.roles) {
      case "1":
        this.default_open = ["1", "2"];
        break;
      case "2":
        this.default_open = ["2"];
        break;
      case "3":
        this.default_open = ["3", "4"];
        break;
      case "4":
        this.default_open = ["4"];
        break;
      case "5":
        this.default_open = ["0"];
        break;
      case "0":
        this.default_open = ["0"];
    }
  },
  methods: {},
  watch: {
    $route(to, from) {
      this.route_active = this.$route.fullPath;
    }
  }
};
</script>
<style scoped="">
/*.el-scrollbar__wrap {
       overflow-x: hidden;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/InspectSuperviseLeft.vue